import React from 'react';
import { Text, i18n, tokens } from '@simplybenefits/sb-ui-library';
import { numberWithCommas } from '../../services/helpers.js';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';

/**
 *
 * @param {*} props
 */
const LifeInsurance = ({ classes, expanded, lifeInsurance, handleChange, isStudent }) => (
    <div style={ classes.block }>
        <Accordion
            square
            onChange={handleChange('lifeInsurance')}
            style={{ boxShadow: 'none' }}
            disableGutters={true}
        >
            <AccordionSummary
                classes={{
                    content: classes.panelContent,
                    expanded: classes.expanded,
                    root: classes.root
                }}
                expandIcon={expanded.includes('lifeInsurance') ? <RemoveIcon /> : <AddIcon />}
                sx={classes.accordionSummary}
            >
                <Text id="lifeinsurance" medium bold>{ i18n.t(tokens.titles.lifeInsurance) }</Text>
            </AccordionSummary>
            <AccordionDetails style={classes.panelDetails}>
                {
                    lifeInsurance.isEligible !== 1 ?
                        <div style={classes.row}>
                            <Text small bold margin="20px 0px 10px 0px">
                                { i18n.t(tokens.labels.coverage.ineligibleForBenefit) }
                            </Text>
                        </div>
                        : 
                        null
                }

                {
                    lifeInsurance.isFlatAmount === 1 ?
                        <Text small bold customStyle={{ flex: 1, marginTop: 10 }}>
                            { i18n.t(tokens.labels.coverage.coverageFlatAmount, { flatAmount: numberWithCommas(lifeInsurance.flatAmount) })}
                        </Text>
                        :
                        <Text small bold customStyle={{ flex: 1, marginTop: 10 }}>
                            { i18n.t(tokens.labels.coverage.coverageTimesEarnings, { timesEarnings: lifeInsurance.timesEarnings })}
                        </Text>
                }

                {
                    lifeInsurance.maxEvidence > 0 ?
                        <Text small margin="5px 0px 0px 0px">
                            { i18n.t(tokens.labels.coverage.maxEvidenceLabel, { maxEvidence: numberWithCommas(lifeInsurance.maxEvidence) }) }
                        </Text>
                        :
                        null
                }

                {
                    lifeInsurance.maxNoEvidence > 0 ?
                        <Text small margin="5px 0px 0px 0px">
                            { i18n.t(tokens.labels.coverage.maxNoEvidenceLabel, { maxNoEvidence: numberWithCommas(lifeInsurance.maxNoEvidence) })}
                        </Text>
                        :
                        null
                }

                <Text small margin="5px 0px 0px 0px">
                    { i18n.t(tokens.labels.coverage.terminalIllnessAdvancedBenefit) }
                </Text>

                { 
                    isStudent ?
                        <Text id="lifeinsurancedetails" small margin="5px 0px 0px 0px">
                            { i18n.t(tokens.labels.coverage.coverageReducesAtAgeStudy, { reducesBy: lifeInsurance.reducesBy, reducesAtAge: lifeInsurance.reducesAtAge })}
                        </Text>
                        :
                        <Text id="lifeinsurancedetails" small margin="5px 0px 0px 0px">
                            { i18n.t(tokens.labels.coverage.coverageReducesAtAge, { reducesBy: lifeInsurance.reducesBy, reducesAtAge: lifeInsurance.reducesAtAge })}
                        </Text>
                }

                { 
                    lifeInsurance.includeSecondReduction ?
                        <>
                            { 
                                isStudent ?
                                    <Text small margin="5px 0px 0px 0px">
                                        { i18n.t(tokens.labels.coverage.furtherCoverageReducesAtAgeStudy, { furtherReducesBy: lifeInsurance.furtherReducesBy, furtherReductionAge: lifeInsurance.furtherReductionAge })}
                                    </Text> 
                                    :
                                    <Text small margin="5px 0px 0px 0px">
                                        { i18n.t(tokens.labels.coverage.furtherCoverageReducesAtAge, { furtherReducesBy: lifeInsurance.furtherReducesBy, furtherReductionAge: lifeInsurance.furtherReductionAge })}
                                    </Text>
                            }
                        </>
                        :
                        null
                }

                { 
                    lifeInsurance.earlyPaymentPrivilege ?
                        <Text small margin="5px 0px 0px 0px">
                            { lifeInsurance.earlyPaymentPrivilegeType }
                        </Text>
                        :
                        null
                }

                {
                    isStudent ?
                        <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.terminatesAtEndOfStudy, { terminationAge: lifeInsurance.terminationAge }) }</Text>
                        :
                        <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.terminatesAtAge, { terminationAge: lifeInsurance.terminationAge }) }</Text>
                }
            </AccordionDetails>
        </Accordion>
    </div>
);

export default LifeInsurance;